import { NotesContext } from "../providers/NotesProvider";
import { useContext } from "react";

export default function useNotesContext() {
  return useContext(NotesContext);
}
